import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-earthy-worthy-aboutus',
  templateUrl: './earthy-worthy-aboutus.component.html'
})
export class EarthyWorthyAboutusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
